module.exports = __webpack_public_path__ + "img/taobao.94b82320.webp";